<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        <ng-container [formGroup]="product">
          <ng-container formGroupName="parameters">
            <pr-input-radio
              formControlName="avSouscriptionOptionExonerationArretTravail"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              [defaultValue]="true"
              columns="5"
            >
            </pr-input-radio>
          </ng-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
